export default "/images/vision_sustainability.webp?93d068c7aa1833f98e4ae4fbeab3591f";